<template>
  <div id="dashboard">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-5 "
        >
          <app-error404 />
          <div class="clearfix" />
        </div>

        <div class="clearfix" />

        <div class="row text-center w-100">
          <p
            class="mt-5 mb-3 text-muted text-center w-100"
            id="copyright"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apperror404 from '../../components/system/404.vue';

export default {
    computed: {
        auth() {
            return this.$store.getters.isAuthenticated;
        }
    },
    components: {
        'app-error404': apperror404
    },
};
</script>




// WEBPACK FOOTER //
// src/components/system/errors.vue